module.exports = __webpack_public_path__ + "static/img/nav_bg.63f79328.png";